import React, { useMemo } from 'react';
import { Button, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { getVariantTemplates } from '../../util/variantTemplates';

const VariantTemplateSelector = ({ categoryName, onSelectTemplate, activeGroupNames }) => {
    const templates = useMemo(() => getVariantTemplates(categoryName), [categoryName]);

    // Normalize active group names for robust deduplication
    const normalizedActiveGroupNames = activeGroupNames.map(name => name?.trim().toLowerCase());

    // Filter out templates that are already added
    const availableTemplates = templates.filter(t => !normalizedActiveGroupNames.includes(t.label.toLowerCase()));

    if (templates.length === 0) {
        return (
            <div style={{ marginBottom: '16px', padding: '12px 16px', background: '#fffbeb', border: '1px dashed #f59e0b', borderRadius: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                    <div style={{ fontSize: '12px', fontWeight: 800, color: '#d97706' }}>No Predefined Templates</div>
                    <div style={{ fontSize: '11px', color: '#92400e', marginTop: '2px' }}>No standard variants configured for this category. You can create custom groups below.</div>
                </div>
            </div>
        );
    }

    if (availableTemplates.length === 0) return null;

    return (
        <div style={{ marginBottom: '16px', background: '#f8fafc', padding: '12px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
            <div style={{ fontSize: '11px', fontWeight: 800, color: '#64748b', textTransform: 'uppercase', marginBottom: '8px' }}>
                Suggested Variant Groups {categoryName ? `for ${categoryName}` : ''}
            </div>
            <Space wrap size="small">
                {availableTemplates.map(template => (
                    <Button 
                        key={template.id} 
                        type="dashed" 
                        size="small" 
                        icon={<span style={{ marginRight: '4px' }}>{template.icon}</span>}
                        onClick={() => onSelectTemplate(template.label)}
                        style={{ borderRadius: '6px', fontWeight: 600, color: '#4776E6', borderColor: '#4776E6', display: 'flex', alignItems: 'center' }}
                    >
                        {template.label}
                    </Button>
                ))}
            </Space>
        </div>
    );
};

export default React.memo(VariantTemplateSelector);
